import React from 'react';
import { Typography as AntdTypography } from 'antd';

// const { Paragraph, Link } = antdTypography

import Text from "./Text";
import Title from "./Title";
export var FontWeightEnum = /*#__PURE__*/function (FontWeightEnum) {
  FontWeightEnum[FontWeightEnum["Regular"] = 400] = "Regular";
  FontWeightEnum[FontWeightEnum["Medium"] = 500] = "Medium";
  FontWeightEnum[FontWeightEnum["Bold"] = 700] = "Bold";
  return FontWeightEnum;
}({});
function Typography() {
  return /*#__PURE__*/React.createElement(AntdTypography, null);
}
Typography.Title = Title;
Typography.Text = Text;
// Typography.Paragraph = Paragraph
// Typography.Link = Link

export default Typography;